<template>
  <div class="traffic-player rounded overflow-hidden position-relative">
    <video
      v-if="canPlay"
      ref="video"
      controls
      autoplay
      muted
      playsinline
      width="100%"
      height="auto"
      style="background: black"
    ></video>

    <div v-else class="cooldown-overlay text-center p-4 bg-dark text-white">
      <h5 class="fw-bold">{{ $t("traffic.waitTitle") }}</h5>
      <p class="mb-0">{{ $t("traffic.waitMessage") }}</p>
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";

export default {
  data() {
    return {
      canPlay: true,
      hlsInstance: null,
    };
  },
  mounted() {
    const video = this.$refs.video;
    const streamUrl = "https://feribot-eurobac.ro/stream/rampa_direct.m3u8";

    if (Hls.isSupported() && this.canPlay) {
      const hls = new Hls({ liveDurationInfinity: true });
      this.hlsInstance = hls;
      hls.loadSource(streamUrl);
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.warn("HLS.js error", data);
        if (data.fatal) {
          setTimeout(() => {
            hls.destroy();
            const newHls = new Hls({ liveDurationInfinity: true });
            newHls.loadSource(streamUrl);
            newHls.attachMedia(video);
          }, 2000);
        }
      });

      // Stop after 30 sec
      setTimeout(() => {
        this.stopPlayback();
      }, 30 * 1000);
    }
  },
  methods: {
    stopPlayback() {
      this.canPlay = false;
      if (this.hlsInstance) {
        this.hlsInstance.destroy();
      }
      const video = this.$refs.video;
      if (video) {
        video.pause();
        video.src = "";
      }
    },
  },
};
</script>


<style scoped>
.traffic-player {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  min-height: 300px;
  position: relative;
}

.cooldown-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
